import React from 'react'

const HighlightBadge = ({icon, title, description, maxWidth = '100%'}) => {
  return (
    <React.Fragment>
      <section className='flex flex-nowrap gap-x-3 items-center'>
        <div className='w-fit'>
          { icon }
        </div>
        <div className='block' style={{maxWidth: maxWidth}}>
          <div className='text-black'>{title}</div>
          <div className='text-[#5D5D5D]'>{description}</div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default HighlightBadge